import OrderService from "@/services/order.service.js";
// import store from "@/stores/index.js";

export default class OrderUsecase {
  constructor () {
    this.orderService = new OrderService();
  }
  async getOrders (options) {
    const res = await this.orderService.list(options);
    return res;
  }
  async exportOrders (options) {
    const res = await this.orderService.export(options);
    return res;
  }
  async getOrderCount (option) {
    const res = await this.orderService.orderCount(option);
    return res;
  }
  async getOrder (options) {
    const res = await this.orderService.get(options);
    return res;
  }
  async getLayouts (options) {
    const res = await this.orderService.layouts(options);
    return res;
  }
  async orderCreate (options) {
    const res = await this.orderService.create(options);
    return res;
  }
  async orderUpdateStatus (options) {
    const res = await this.orderService.updateStatus(options);
    return res;
  }
  // 「レイアウト調整を開始する」ボタンよりステータスを遷移させるときに mutation orderStartLayoutRevision を利用する
  async orderStartLayoutRevision (options) {
    const res = await this.orderService.orderStartLayoutRevision(options);
    return res;
  }
  async orderDelete (options) {
    const res = await this.orderService.delete(options);
    return res;
  }
  async orderUpdate (options) {
    const res = await this.orderService.updateOrder(options);
    return res;
  }
  async confirmOrder (options) {
    const res = await this.orderService.orderConfirm(options);
    return res;
  }
  async orderAssignStaff (options) {
    const res = await this.orderService.updateAssignStaff(options);
    return res;
  }
  // 基幹システムから商品情報を取得
  async getKikanOrderDetail (option) {
    const res = await this.orderService.getKikanOrderDetail(option);
    return res;
  }
  // 自由項目の取得
  async getOrderCustomFieldConfig (option) {
    const res = await this.orderService.getOrderCustomFieldConfig(option);
    return res;
  }
  // 自由項目の更新
  async updateOrderCustomFieldConfig (option) {
    const res = await this.orderService.updateOrderCustomFieldConfig(option);
    return res;
  }
  // 支店間の共有設定を取得
  async getOrderCustomFieldConfigSource (option) {
    const res = await this.orderService.getOrderCustomFieldConfigSource(option);
    return res;
  }
  // レイアウト画像の追加
  async addLayoutImage (options) {
    await this.orderService.adapter.init();
    const res = await this.orderService.orderAddLayoutImage(options);
    return res;
  }
  // レイアウト画像の削除
  async removeLayoutImage (options) {
    await this.orderService.adapter.init();
    const res = await this.orderService.orderRemoveLayoutImage(options);
    return res;
  }
  // レイアウト画像の校了
  async approveLayoutImage (options) {
    await this.orderService.adapter.init();
    const res = await this.orderService.orderApproveLayoutImage(options);
    return res;
  }
  // レイアウト画像の校了取消
  async unapproveLayoutImage (options) {
    await this.orderService.adapter.init();
    const res = await this.orderService.orderUnapproveLayoutImage(options);
    return res;
  }
  // 支店間の共有設定を更新
  async updateOrderCustomFieldConfigSource (option) {
    if (
      option &&
      option.clientGroupId === ""
    ) {
      // 支店の指定を解除する場合は null を指定する
      option.clientGroupId = null;
    }

    const res = await this.orderService.updateOrderCustomFieldConfigSource(option);
    return res;
  }
}
